(function($){
	
	var navHover = function(){
		$( '.default-navigation li.menu-item-has-children' ).hoverIntent({
			over: function( ){
				if ( $( window ).width() > 991 ) {
					$(this).addClass( 'over' );
				}
			},
			out: function( ){
				if ( $( window ).width() > 991 ) {
					$(this).removeClass( 'over' );
				}
			},
			timeout: 100
		});
		
		$( '.default-navigation li.menu-item-has-children > a' ).on( 'keydown', function( e ){
			// if the key pressed is enter open the sub nav, if the enter key is pressed again, open the link.
			// if the esc key is pressed close the sub nav.
			if ( e.keyCode == 13 && ! $( this ).parent().hasClass( 'over' ) ) {
				e.preventDefault();
				$( this ).parent().addClass( 'over' );
			} else if ( /^Esc(ape)?$/.test(e.key) ) {
				$( this ).parent().removeClass( 'over' );
			}
		});
		
	};
	
	var toggleSubnav = function( e ) {
		e.preventDefault();
		var parentItem = $(this).closest('.menu-item-has-children');
		parentItem.toggleClass( 'over' );
	};
	
	$(document).ready(function(){
	
		navHover();
        $(".search-btn").on("click", function (e) {
			e.preventDefault();
			var parent = this.parentElement;
			$(".search-form").removeClass('d-none');
			$(".search-btn").addClass('d-none');
			// openSearch = !openSearch;
			$( 'input[name="s"]', parent ).focus();
			
		});
		
		$( "#mobile-menu li.menu-item-has-children > a").on('click', toggleSubnav );

		$( '.footer-heading' ).on('click', function(e){
			if ($(window).width() < 768) {
            e.preventDefault();
            $( this ).siblings('.sub-menu').toggleClass( 'd-none' );
			$( this ).toggleClass( 'open' );
		}
        });

		$( '.mobile-search .search-form' ).removeClass( 'd-none' );
	
	});
	
})(jQuery);